import { fromJS } from 'immutable';

import { fetchRolesRoutine, saveRoleRoutine, removeRoleRoutine } from '../routines';
import { updateOrAddMap } from './helper';

const initialState = fromJS({
  roles: [],
  role: {},
  loading: true,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchRolesRoutine.SUCCESS:
      return state.set('roles', fromJS(action.payload.response || [])).set('loading', false);
    case fetchRolesRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);
    case saveRoleRoutine.TRIGGER:
      return state.updateIn(['roles'], updateOrAddMap(fromJS(action.payload)));
    case removeRoleRoutine.TRIGGER:
      console.log('remove', action.payload);
      return state.updateIn(['roles'], (roles) => {
        return roles.filter((role, roleId) => {
          return roleId !== action.payload.id;
        });
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/roles.js